<template>
  <nav :style="cssProps" class="tabs" :class="wrapperClass">
    <button
      class="tabs__item"
      type="button"
      v-for="tab in filterTabs"
      :ref="tab.value"
      :key="tab.title"
      :class="[{
        'tabs__item_active' : tab.value === currentTab },
        tab.value === currentTab && tabActiveClass ? tabActiveClass: '',
        tabClass,
      ]"
      :disabled="tab.disabled || false"
      @click="$emit('onClick', tab.value)"
      v-html="tab.title"
    />

    <div
      class="tabs__active-line"
      :class="lineClass"
      :style="{ width: `${activeLineWidth}px`, transform: `translateX(${activeLineOffset}px)` }"
    />
  </nav>
</template>

<script>
export default {
  name: 'tab',
  props: {
    currentTab: {
      type: String,
      required: true
    },
    tabs: {
      type: Array,
      required: true

    },
    updated: {
      type: [Boolean, String, Array],
      default: undefined
    },
    wrapperClass: {
      type: String,
      default: 'default-tabs',
      required: false
    },
    tabClass: {
      type: String,
      default: 'default-tabs__item',
      required: false
    },
    tabActiveClass: {
      type: String,
      default: 'default-tabs__item_active',
      required: false
    },
    lineClass: {
      type: String,
      default: 'default-tabs__active-line',
      required: false
    },
    borderColor: {
      type: String,
      default: 'black',
      required: false
    },
    textColor: {
      type: String,
      default: 'grey',
      required: false
    },
    textColorActive: {
      type: String,
      default: 'black',
      required: false
    }
  },
  watch: {
    currentTab (newCurrentTab) {
      if (this.newTab === newCurrentTab) return
      this.moveActiveLine(newCurrentTab)
    },
    updated () {
      this.moveActiveLine(this.currentTab)
    }
  },
  data: () => ({
    activeLineWidth: 0,
    activeLineOffset: 0,
    newTab: ''
  }),
  computed: {
    filterTabs () {
      return this.tabs.filter((el) => !el.disabled)
    },
    cssProps () {
      return {
        '--border-color': this.borderColor,
        '--text-color': this.textColor,
        '--text-active-color': this.textColorActive,
        'margin-bottom': '-2px'
      }
    }
  },
  methods: {
    handleClick (value) {
      let element = this.$el
      this.moveActiveLine(value)
      element.scrollLeft = this.activeLineOffset
      this.newTab = value
    },
    moveActiveLine (newValue) {
      if (!this.currentTab) return

      if (!this.$refs || !this.$refs[newValue] || !this.$refs[newValue][0]) return
      const element = this.$refs[newValue][0]

      this.activeLineWidth = element.clientWidth
      this.activeLineOffset = element.offsetLeft
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.moveActiveLine(this.currentTab)
    })
    this.moveActiveLine(this.currentTab)
  }
}
</script>

<style lang="sass">
.tabs
  scroll-behavior: smooth
  width: 100%

.default-tabs
  position: relative
  margin: 0 auto
  white-space: nowrap
  overflow: auto hidden

.default-tabs__item
  margin: 0
  font-weight: 800
  padding-bottom: 0px
  padding-top: 14px
  padding-left: 14px
  padding-right: 14px
  font-size: 16px
  letter-spacing: 0.8px
  color: var(--text-color)
  text-decoration: none
  border: none
  background-color: transparent
  //border-bottom: 2px solid transparent
  cursor: pointer
  transition: all 0.15s
  @media screen and (max-width: 920px)
    font-size:10px
  @media screen and (max-width: 1050px)
    font-size:14px

.default-tabs__item_active
  color: var(--text-active-color)

.default-tabs__item
  &:disabled
    border-bottom: 0px solid transparent
    color: gray
    cursor: default
    opacity: 0.5

  &:enabled:hover
    border-bottom: 0px solid var(--border-color)
    color: var(--text-active-color)

  &:enabled:focus
    outline: none
    border-bottom: 0px solid var(--border-color)

  &:first-child
    margin-left: 0

  &:last-child
    margin-right: 0

.default-tabs__active-line
  position: inherit
  height: 2px
  background-color: var(--border-color)
  transition: transform 0.4s ease, width 0.4s ease
</style>
